import { ScrollAdDispatcher } from "./ScrollAdDispatcher";
import { StripChatAdDispatcher } from "./stripChat/StripChatAdDispatcher";
import { AdUnitsKeys } from "./config/units";
import { useExperiments } from "hooks/useExperiments";
import { Fragment } from "react";

interface IProps {
  position: number;
  mobileAds: AdUnitsKeys[];
  desktopAds: AdUnitsKeys[];
}

export const FeedAds = ({ position, mobileAds, desktopAds } : IProps) => {
  const { noAds = false } = useExperiments();

  if (noAds) {
    return null;
  }

  return (
    <Fragment>
      <ScrollAdDispatcher
        position={position + 1}
        mobileAds={mobileAds}
        desktopAds={desktopAds}
      />
      <StripChatAdDispatcher position={position} />
    </Fragment>
  );
};
